var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{attrs:{"outlined":"","rounded":"","color":"#173c93","to":_vm.getBackRoute()}},[_vm._v(" Voltar ")]),_c('read-article',{attrs:{"article":_vm.foundPrivacyNews}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }